/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GoogleCalendarConnectResponseDto,
  GoogleCalendarStatusResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GoogleCalendarConnectResponseDtoFromJSON,
    GoogleCalendarConnectResponseDtoToJSON,
    GoogleCalendarStatusResponseDtoFromJSON,
    GoogleCalendarStatusResponseDtoToJSON,
} from '../models/index';

export interface GoogleCalendarCallbackRequest {
    code: string;
}

/**
 * 
 */
export class ProviderGoogleCalendarApi extends runtime.BaseAPI {

    /**
     * Generates the Google OAuth consent URL for the current provider
     * Start Google Calendar OAuth connection
     */
    async connectGoogleCalendarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleCalendarConnectResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/google-calendar/connect`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleCalendarConnectResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generates the Google OAuth consent URL for the current provider
     * Start Google Calendar OAuth connection
     */
    async connectGoogleCalendar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleCalendarConnectResponseDto> {
        const response = await this.connectGoogleCalendarRaw(initOverrides);
        return await response.value();
    }

    /**
     * Removes the current provider\'s stored Google Calendar tokens
     * Disconnect Google Calendar
     */
    async disconnectGoogleCalendarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/google-calendar`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes the current provider\'s stored Google Calendar tokens
     * Disconnect Google Calendar
     */
    async disconnectGoogleCalendar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disconnectGoogleCalendarRaw(initOverrides);
    }

    /**
     * Returns whether the current provider has connected Google Calendar
     * Get Google Calendar connection status
     */
    async getGoogleCalendarStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleCalendarStatusResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/google-calendar/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleCalendarStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns whether the current provider has connected Google Calendar
     * Get Google Calendar connection status
     */
    async getGoogleCalendarStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleCalendarStatusResponseDto> {
        const response = await this.getGoogleCalendarStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Exchanges the OAuth authorization code for tokens and stores them
     * Complete Google Calendar OAuth connection
     */
    async googleCalendarCallbackRaw(requestParameters: GoogleCalendarCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling googleCalendarCallback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/google-calendar/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Exchanges the OAuth authorization code for tokens and stores them
     * Complete Google Calendar OAuth connection
     */
    async googleCalendarCallback(requestParameters: GoogleCalendarCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.googleCalendarCallbackRaw(requestParameters, initOverrides);
    }

}
